import { Injectable, signal } from "@angular/core";
import { API_URL, APP_CONFIG, LOGIN_URL } from "app.config";
import { AppStateConstant } from "../constants/AppState.constant";
import { EventsConstant } from "../constants/Events.constant";
import { Events } from "./Events";
import { HttpHelper } from "./http/HttpHelper";
import { UtilCommon } from "./UtilCommon";
import { MOMENT_DATE_FORMAT } from "../config/MomentDateFormat.config";
import { HomeService } from "app/modules/home/home.service";
import { FireStoreService } from "./services/firestore.service";
import * as moment from 'moment';
import { signOut } from "aws-amplify/auth";
import { IBreadcumMenuItem } from "./breadcumMenu.service";
import { BehaviorSubject } from "rxjs";
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({
    providedIn: 'root'
})
export class AppState {
    appState: any = undefined;
    pageSize = 0;
    menuData: any[] = [];
    openMenu: boolean;
    scrollTopMenu: number;
    userAttributeValues: any;
    userInfo;
    userAvatar;
    unitInfo;
    lstBookMark = [];
    accessToken = '';
    idToken = '';
    refreshToken = '';
    serverToken = '';
    isMobile = true;
    callFromSignPage = false;
    profileSettings;
    tokenSignPage;
    settingsApp = {};
    breadcumMenu = signal<IBreadcumMenuItem[]>([]);
    cachedKstbGoal: Record<string, any> = {};
    cachedMasterDataGoal: any;
    cachedRRM: any;
    cachedMasterDataRequest: any;
    cachedMasterDataOffer: any;
    cachedMasterDataProgramEvent: any;
    cachedQuestionnaire: any[] | null = null;
    cachedAllSkill: any;

    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    // Show loading
    showLoading() {
        this.loadingSubject.next(true);
    }

    // Hide loading
    hideLoading() {
        this.loadingSubject.next(false);
    }

    constructor(
        private httpHelper: HttpHelper,
        private homeService: HomeService,
        private _fireStoreService: FireStoreService,
        private oauthService: OAuthService
    ) {
        this.menuData = [];
        this.pageSize = APP_CONFIG.LIMIT_QUERY;
        let appState: any = localStorage.getItem(AppStateConstant.appState);
        if (appState) {
            appState = JSON.parse(appState);
            this.setAppState(appState);
        }
        this.openMenu = true;
        this.scrollTopMenu = 0;
        this.userInfo = null;
        this.userAvatar = null;
        this.settingsApp = UtilCommon.genSettingsApp();

    }

    setAppState(appState: any): void {
        this.appState = appState;
        if (appState) {
            this.setUserInfo(appState);
            Events.publish(EventsConstant.LoadUserInfo, appState);
            localStorage.setItem(AppStateConstant.appState, JSON.stringify(appState));
        }
        (<any>window).ICRM_APP_STATE = appState;
    }

    getUrlCurrent(): string {
        return localStorage.getItem('urlCurrent');
    }

    setUrlCurrent(value): void {
        localStorage.setItem('urlCurrent', value.toString().replace('#', ''));
    }

    getAppState(): any {
        try {
            if (this.appState) {
                return this.appState;
            }
            const app = localStorage.getItem(AppStateConstant.appState);
            if (app) {
                this.appState = JSON.parse(app);
            }
        } catch (e) {

        }
    }

    getAppStateUsername(): string {
        return localStorage.getItem(AppStateConstant.userName);
    }

    setAppStateUsername(username: any): void {
        localStorage.setItem(AppStateConstant.userName, username);
    }

    getLanguage(): string {
        const profileSettings = this.appState?.profileSettings;
        if (profileSettings) {
            const language = profileSettings?.language;
            if (language) {
                localStorage.setItem(AppStateConstant.Language, language);
                return language;
            }
        }
        return localStorage.getItem(AppStateConstant.Language) || APP_CONFIG.DEFAULT_LANGUAGE
    }

    isLoggedIn(): boolean {
        return this.getAppState() ? true : false;
    }

    clearLogout(isKeepSigninType: boolean = false): void {
        try {
            let language: string = 'en'; //localStorage.getItem('language');
            let version: string = localStorage.getItem('version');
            let urlCurrent: string = localStorage.getItem('urlCurrent');
            const signinType = localStorage.getItem(AppStateConstant.SIGNIN_AZURE_AD);

            if (!language || language === 'null') {
                language = APP_CONFIG.DEFAULT_LANGUAGE;
            }
            if (!version || version === 'null') {
                version = APP_CONFIG.VERSION;;
            }
            if (signinType === AppStateConstant.SIGNIN_AWS_COGNITO) {
                signOut({ global: true }).then(data => {
                });
            }
            if (signinType === AppStateConstant.SIGNIN_ZITADEL) {
                this.logoutZitadel();
            }
            localStorage.clear();
            localStorage.setItem('version', version);
            localStorage.setItem('language', language);
            localStorage.setItem('urlCurrent', urlCurrent);
            if (isKeepSigninType) {
                localStorage.setItem(AppStateConstant.SIGNIN_AZURE_AD, signinType);
            }
            this.changeConfigNumberDirective(language);
            this.menuData = [];
            this.openMenu = true;
            this.scrollTopMenu = 0;
            this.profileSettings = null;
            window[AppStateConstant.appState] = null;
            sessionStorage.clear();
            this.homeService.clearData();
            this._fireStoreService.logout();
            this.setAppState(null);
            this.isMobile = false;
            window['isMobile'] = false;
            this.breadcumMenu.set([]);
        } catch (e) {
        }
    }

    // Lưu user atribute ở đây
    getPageSizeOptions(): any[] {
        return [20, 50, 100, 200];
    }

    getPageSize(): number {
        return this.pageSize;
    }

    getPageDefault() {
        return 'home';
    }

    // Kiểm tra xem bạn được quyền truy cập vao page nao
    accessPage(accessLink: string): boolean {
        if (!this.appState) {
            return true;
        }
        if (!this.getScreen()) {
            return true;
        }
        const pages: any = this.getScreen();
        if (pages) {
            for (const page of pages) {
                if (page.link && page.children && page.children.length === 0) {
                    if (accessLink.indexOf(page.link) > -1) {
                        return true;
                    }
                }
                for (const ch of page.children) {
                    if (ch.children) {
                        for (const item of ch.children) {
                            if (UtilCommon.isArray(item.children)) {
                                for (const itemChild of item.children) {
                                    if (accessLink.indexOf(itemChild.link) > -1) {
                                        return true;
                                    }
                                }
                            }
                            else if (accessLink.indexOf(item.link) > -1) {
                                return true;
                            }
                        }
                    } else if (accessLink.indexOf(ch.link) > -1) {
                        return true;
                    }
                }
            }
            return false;
        }
        // Hien tai bo qua ham nay cho screen hien thi
        return true;
    }

    // Kiêm tra xem bạn được quyền sử dụng những function nào
    accessFunction(accessLink: string, functionName: string): boolean {
        if (!this.appState) {
            return true;
        }
        const pages: any = this.getScreen();
        let functions: any = null;

        for (const page of pages) {
            if (!page.route) {
                continue;
            }
            if (accessLink.indexOf(page.route) > -1) {
                functions = page.func;
                if (functions) {
                    return functions[functionName];
                } else {
                    return false;
                }
            }
        }
        return true;
    }

    // Kiêm tra xem bạn được quyền sử dụng những function nào
    hasPermission(functionName: string): boolean {
        if (!window['IS_CHECK_PERMISSION']) {
            return true;
        }

        if (!this.appState) {
            return false;
        }
        if (this.appState.permissions) {
            for (const per of this.appState.permissions) {
                if (per.target === functionName) {
                    return true;
                }
            }
        }
        return false;
    }

    hasRole(roleName: string): boolean {
        if (!this.appState) {
            return false;
        }
        if (this.appState.authorities) {
            for (const per of this.appState.authorities) {
                if (per.authority === roleName) {
                    return true;
                }
            }
        }
        return false;
    }

    setUserInfo(userInfo: any): void {
        this.userInfo = userInfo;
    }

    setScreen(menuData: any): void {
        this.appState.screen = menuData;
    }

    getScreen(): any {
        if (this.appState) {
            return this.appState.screen;
        }
        return null;
    }

    getCompanyCode(): any {
        let userInfo: any = this.getUserinfo();
        if (!userInfo) {
            return '';
        }
        userInfo = userInfo.moreInfo;
        if (!userInfo) {
            return '';
        }
        return userInfo.tenantCode;
    }

    getAppCode(): any {
        let userInfo: any = this.getUserinfo();
        if (!userInfo) {
            return '';
        }
        userInfo = userInfo.moreInfo;
        if (!userInfo) {
            return '';
        }
        return userInfo.appCode;
    }

    getUserId(): number {
        let userInfo: any = this.getUserinfo();
        if (!userInfo) {
            return -1;
        }
        userInfo = userInfo.moreInfo;
        if (!userInfo) {
            return -1;
        }
        return userInfo.userId;
    }

    getAttributeValues(): any {
        return this.userAttributeValues || {};
    }

    getUserinfo(): any {
        return this.appState;
    }

    getAttributeValue(attributeName: string): Promise<any> {
        const appCode = this.getAppState().moreInfo?.tenantCode || "";
        const userId = this.getAppState().moreInfo?.userId || "";
        const url: string = API_URL.ATTRIBUTE.GET + `?appCode:${appCode}&userId=${userId}&attribute=${encodeURIComponent(attributeName)}`;
        return this.httpHelper.methodGetService(url, APP_CONFIG.QUERY_TIME_OUT);
    }

    setAttributeValue(attributeName: string, atributeValue: string): Promise<any> {
        const request = {
            'attribute': attributeName,
            'attrValue': atributeValue,
            'tenantCode': this.getAppState().moreInfo?.tenantCode || "",
            'appCode': this.getAppState().moreInfo?.appCode || "",
            'userId': this.getAppState().moreInfo?.userId || ""
        };
        const url: string = API_URL.ATTRIBUTE.SET;
        const params = `${JSON.stringify(request)}`;
        return this.httpHelper.methodPostJsonService(url, params, APP_CONFIG.QUERY_TIME_OUT);
    }

    getUserInfo(): Promise<any> {
        return this.httpHelper.methodGetService(LOGIN_URL.USER_INFO);
    }

    getMenuTree(): Promise<any> {
        const url: string = LOGIN_URL.MENU;
        return this.httpHelper.methodGetService(url);
    }

    getLowcoderFormKeyApi(): Promise<any> {
        let url: string = 'assets/json/lowcoder-form-prod.json';
        if (window.location.origin.indexOf('localhost') > -1
            || window.location.origin.indexOf('uat') > -1) {
            url = 'assets/json/lowcoder-form-uat.json';
        } else if (window.location.origin.indexOf('staging') > -1) {
            url = 'assets/json/lowcoder-form-staging.json';
        }
        return this.httpHelper.methodGetService(url);
    }

    getHasuraToken(): Promise<any> {
        const url: string = LOGIN_URL.GET_HASURA_TOKEN;
        const params = {}
        return this.httpHelper.methodPostJsonService(url, params, APP_CONFIG.COMMAND_TIME_OUT);
    }

    logout(username: string): Promise<any> {
        const urlLogout: string = APP_CONFIG.HOST_NAME_LOGIN + APP_CONFIG.LOGOUT_SERVICE,
            params: string = 'username=' + username;
        return this.httpHelper.actionLogOut(urlLogout, APP_CONFIG.COMMAND_TIME_OUT);
    }

    getTokenFormServer(idToken: string, accessToken: string, authProvider: string = null): Promise<any> {
        const url: string = LOGIN_URL.GET_TOKEN;
        const params = {
            "idToken": idToken,
            "accessToken": accessToken,
            'appCode': APP_CONFIG.APP_CODE,
            'tenantCode': APP_CONFIG.TENANT,
        }
        if (authProvider) {
            params['authProvider'] = authProvider;
        }
        return this.httpHelper.methodPostJsonService(url, params, APP_CONFIG.COMMAND_TIME_OUT);
    }

    getProfileInfoNew(): Promise<any> {
        const url: string = LOGIN_URL.GET_PROFILE_NEW;
        return this.httpHelper.methodGetService(url, APP_CONFIG.COMMAND_TIME_OUT);
    }

    getAccessToken(): string {
        if (this.accessToken) {
            return this.accessToken;
        }
        return localStorage.getItem(AppStateConstant.AccessToken);
    }

    getIdToken(): string {
        if (this.idToken) {
            return this.idToken;
        }
        return localStorage.getItem(AppStateConstant.IdToken);
    }

    getServerToken(): string {
        if (this.serverToken) {
            return this.serverToken;
        }
        return localStorage.getItem(AppStateConstant.ServerToken);
    }

    getRefreshToken(): string {
        if (this.refreshToken) {
            return this.refreshToken;
        }
        return localStorage.getItem(AppStateConstant.RefreshToken);
    }

    async logoutCognito() {
        // try {
        //     const dataLogin = await Auth.signOut();
        //     if (UtilCommon.isNotNull(dataLogin)) {
        //     }
        // } catch (e) {
        // }
    }

    logoutZitadel(): void {
        try {
            // Get the ID token for the logout hint
            const idToken = this.oauthService.getIdToken();

            if (idToken) {
                // Revoke the token and logout
                // This will redirect to Zitadel's end_session_endpoint
                // and then redirect back to the configured post_logout_redirect_uri
                this.oauthService.revokeTokenAndLogout({
                    id_token_hint: idToken
                });
            } else {
                // If no ID token, just do local logout
                this.oauthService.logOut();
            }
        } catch (e) {
            console.error('Zitadel logout error:', e);
            // Fallback to local logout if remote logout fails
            this.oauthService.logOut();
        }
    }

    async getSession() {
        try {
            // const dataSession = await Auth.currentSession();
            // if (UtilCommon.isNotNull(dataSession)) {
            //     if (dataSession.isValid()) {
            //         const accessToken = dataSession?.getAccessToken().getJwtToken();
            //         const idToken = dataSession?.getIdToken().getJwtToken();
            //         const refreshToken = dataSession?.getRefreshToken().getToken();
            //         this.accessToken = accessToken;
            //         this.idToken = idToken;
            //         this.refreshToken = refreshToken;
            //         localStorage.setItem(AppStateConstant.AccessToken, accessToken);
            //         localStorage.setItem(AppStateConstant.IdToken, idToken);
            //         localStorage.setItem(AppStateConstant.RefreshToken, refreshToken);
            //     }
            //     // het session
            // }
            // console.log(dataLogin);
        } catch (e) {
        }
    }

    setEnvelopId(evelopId, isClear) {
        if (isClear) {
            sessionStorage.setItem('evelopAggId', '');
            return;
        }
        sessionStorage.setItem('evelopAggId', evelopId);
    }

    checkRoutePassLogin(hash) {
        const routesToPassLogin = [
            'accept-member',
            'not-found',
            'forgot-password',
            'sign-up',
            'sign-in',
            'checktoken',
            'confirm-sign',
            'sign-document',
            'resetpass',
            'confirm-sign-social',
            'reset-password',
            'unlock-session',
            'verify-token',
            'offer-letter-review',
            'graph-redirect'
        ];

        // Return false if the hash matches 'sign-document/sign/'
        if (hash.includes('sign-document/sign/')) {
            return false;
        }

        // Check if any of the routes are included in the hash
        return routesToPassLogin.some(route => hash.includes(route));
    }


    getDateTimeFromProfileSetting() {
        const profileSettings = this.getAppState()?.moreInfo?.profileSetting;
        if (!profileSettings) {
            return MOMENT_DATE_FORMAT.FULL_TIME;
        }
        const timeFormat = profileSettings?.formatSetting?.date?.toUpperCase() + ' ' + profileSettings?.formatSetting?.time;
        if (timeFormat === 'undefined undefined' || !timeFormat || timeFormat === 'undefined') {
            return MOMENT_DATE_FORMAT.FULL_TIME;
        }
        return timeFormat ?? MOMENT_DATE_FORMAT.FULL_TIME;
    }

    getDateFromProfileSetting() {
        const profileSettings = this.getAppState()?.moreInfo?.profileSetting;
        if (!profileSettings) {
            return MOMENT_DATE_FORMAT.ONLY_DATE;
        }
        const dateFormat = profileSettings?.formatSetting?.date;
        if (dateFormat) {
            return dateFormat[0];
        }
        const dateTime = profileSettings?.formatSetting?.dateTime?.toString()?.split(' ');
        if (UtilCommon.checkISArray(dateTime) && dateTime.length == 1) {
            return dateTime[0];
        }
        return MOMENT_DATE_FORMAT.ONLY_DATE;
    }

    getLocaleFromProfileSetting() {
        return 'en-US';
    }

    handleMenu(menus) {
        return menus;
        const menu = [];
        for (const m of menus) {
            if (m.menuCode !== 'APPLICATION.6') {
                const menuChild = m.children;
                if (UtilCommon.isArray(menuChild)) {
                    const mChild = menuChild[0].children;
                    if (UtilCommon.isArray(mChild)) {
                        menu.push(m);
                    }
                }
            }
        }
        return menu;
    }

    handleMenuParent(menuCodeParent) {
        let menuChild = this.getScreen();
        if (!menuChild && localStorage.getItem('menuFinal')) {
            menuChild = JSON.parse(localStorage.getItem('menuFinal'));
        }
        const menuData = [];
        if (UtilCommon.isArray(menuChild)) {
            for (const menu of menuChild) {
                if (menu.menuCode === menuCodeParent) {
                    const menuChild = menu.children;
                    if (UtilCommon.checkISArray(menuChild)) {
                        for (const mParent of menuChild) {
                            const parentMenu = 'menu.' + mParent.menuCode;
                            const menuTemp =
                            {
                                id: parentMenu,
                                title: 'MENU.' + mParent.title,
                                type: 'group',
                                children: [
                                ]
                            };
                            const menuChildChildren = mParent.children;
                            if (UtilCommon.checkISArray(menuChildChildren)) {
                                for (const mChild of menuChildChildren) {
                                    menuTemp.children.push({
                                        id: parentMenu + '.' + mChild.menuCode,
                                        title: 'MENU.' + mChild.menuName,
                                        type: 'basic',
                                        link: '/' + UtilCommon.handleHistoryToken(mChild.historyToken)
                                    })
                                }
                            }
                            menuData.push(menuTemp);
                        }
                    }

                }
            }
        }
        return menuData;
    }

    checkPermission(functionName: string): boolean {
        const permissions = this.appState?.permissions;
        if (UtilCommon.isArray(permissions)) {
            for (const per of permissions) {
                if (per.target === functionName) {
                    return true;
                }
            }
        }
        return false;
    }

    private configNumberDirective = {
        decimal: true,
        decimalLength: 3,
        decimalSeparator: '.',
        groupSeparator: ','
    };

    private configNumberDirectiveUSD = {
        decimal: true,
        decimalLength: 2,
        decimalSeparator: '.',
        groupSeparator: ','
    };
    private configNumberDirectiveVND = {
        decimal: true,
        decimalLength: 0,
        decimalSeparator: '.',
        groupSeparator: ','
    };

    changeConfigNumberDirective(language: string) {
        let configNumberDirective = JSON.stringify({
            'USD': {
                decimal: true,
                decimalLength: 2,
                decimalSeparator: ',',
                groupSeparator: '.'
            },
            'VND': {
                decimal: true,
                decimalLength: 0,
                decimalSeparator: ',',
                groupSeparator: '.'
            }
        });
        // this.configNumberDirectiveUSD = {
        //     decimal: true,
        //     decimalLength: 2,
        //     decimalSeparator: ',',
        //     groupSeparator: '.'
        // };
        // this.configNumberDirectiveVND = {
        //     decimal: true,
        //     decimalLength: 0,
        //     decimalSeparator: ',',
        //     groupSeparator: '.'
        // };
        if (language === 'en') {
            configNumberDirective = JSON.stringify({
                'USD': {
                    decimal: true,
                    decimalLength: 2,
                    decimalSeparator: '.',
                    groupSeparator: ','
                },
                'VND': {
                    decimal: true,
                    decimalLength: 0,
                    decimalSeparator: '.',
                    groupSeparator: ','
                }
            });
            // this.configNumberDirectiveUSD = {
            //     decimal: true,
            //     decimalLength: 2,
            //     decimalSeparator: '.',
            //     groupSeparator: ','
            // };
            // this.configNumberDirectiveVND = {
            //     decimal: true,
            //     decimalLength: 0,
            //     decimalSeparator: '.',
            //     groupSeparator: ','
            // };
        }
        localStorage.setItem('configNumberDirective', configNumberDirective);
    }

    getConfigNumberDirective(language: string = 'en') {
        const configNumberDirective = localStorage.getItem('configNumberDirective');
        let configNumberDirectiveVND = this.configNumberDirectiveVND;
        let configNumberDirectiveUSD = this.configNumberDirectiveUSD;
        if (configNumberDirective) {
            const configNumberDirectiveObj = JSON.parse(configNumberDirective);
            if (configNumberDirectiveObj['VND']) {
                configNumberDirectiveVND = configNumberDirectiveObj['VND'];
            }
            if (configNumberDirectiveObj['USD']) {
                configNumberDirectiveUSD = configNumberDirectiveObj['USD'];
            }
        }

        if (language === 'vi') {
            return configNumberDirectiveVND;
        }
        return configNumberDirectiveUSD;
    }

    formatNumberCurrencyExt(valueInput: any, language: string = 'en'): any {
        let configNumberCurrencyParse = {
            decimalSeparator: '.',
            groupSeparator: ','
        };
        if (!valueInput) {
            return 0;
        }
        valueInput = valueInput + '';
        if ((!valueInput && valueInput != 0) || valueInput.trim().length == 0) {
            return '';
        }

        let decimalValue = '';
        let decimalSeparator = '';
        let value = valueInput;

        if (valueInput.indexOf(configNumberCurrencyParse.decimalSeparator) > -1
            && this.getConfigNumberDirective(language).decimal) {
            let arr = valueInput.split(configNumberCurrencyParse.decimalSeparator);
            value = arr[0];
            if (!value || value.length === 0) {
                value = '0';
            }
            decimalValue = arr[1].substring(0, this.getConfigNumberDirective(language).decimalLength);
            decimalSeparator = this.getConfigNumberDirective(language).decimalSeparator;
        }

        if (isNaN(value)) {
            return value + decimalSeparator + decimalValue;
        }
        if (value === 0) {
            return value + decimalSeparator + decimalValue;
        }
        let sign = (value == (value = Math.abs(value)));
        value = Math.floor(value * 100 + 0.50000000001);
        value = Math.floor(value / 100).toString();
        for (let i = 0, length = Math.floor((value.length - (1 + i)) / 3); i < length; i++) {
            value = value.substring(0, value.length - (4 * i + 3)) + this.getConfigNumberDirective(language).groupSeparator + value.substring(value.length - (4 * i + 3));
        }
        if (decimalValue.length > 0) {
            value = value + decimalSeparator + decimalValue;
        }
        return (((sign) ? '' : '-') + value);
    }

    formatDate(value: any, format: string = MOMENT_DATE_FORMAT.ONLY_DATE): string {
        let language: any = 'vi'; //localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE
        if (language === 'vi') {
            format = MOMENT_DATE_FORMAT.ONLY_DATE_VN;
        }
        if (value && (typeof value === 'number' || typeof value === 'string')) {
            const d: Date = new Date(value);
            const m: moment.Moment = moment(d);
            return m.format(format);
        } else if (value && value instanceof Date) {
            const m: moment.Moment = moment(value);
            return m.format(format);
        }
        return '';
    }

    formatDateFullTime(value: any, format: string = MOMENT_DATE_FORMAT.FULL_TIME): string {
        let language: any = 'vi'; //localStorage.getItem("language") || APP_CONFIG.DEFAULT_LANGUAGE
        if (language === 'vi') {
            format = MOMENT_DATE_FORMAT.FULL_TIME_VN;
        }
        if (value && (typeof value === 'number' || typeof value === 'string')) {
            const d: Date = new Date(value);
            const m: moment.Moment = moment(d);
            return m.format(format);
        } else if (value && value instanceof Date) {
            const m: moment.Moment = moment(value);
            return m.format(format);
        }
        return '';
    }

    formatNumberCurrencyExt_VND(valueInput: any): any {
        let configNumberCurrencyParse = {
            decimalSeparator: '.',
            groupSeparator: ','
        };
        if (!valueInput) {
            return 0 + currency_VND;
        }
        valueInput = valueInput + '';
        if ((!valueInput && valueInput != 0) || valueInput.trim().length == 0) {
            return '';
        }

        let decimalValue = '';
        let decimalSeparator = '';
        let value = valueInput;

        if (valueInput.indexOf(configNumberCurrencyParse.decimalSeparator) > -1
            && this.getConfigNumberDirective().decimal) {
            let arr = valueInput.split(configNumberCurrencyParse.decimalSeparator);
            value = arr[0];
            if (!value || value.length === 0) {
                value = '0';
            }
            decimalValue = arr[1].substring(0, this.getConfigNumberDirective().decimalLength);
            decimalSeparator = this.getConfigNumberDirective().decimalSeparator;
        }

        if (isNaN(value)) {
            return value + decimalSeparator + decimalValue + currency_VND;
        }
        if (value === 0) {
            return value + decimalSeparator + decimalValue + currency_VND;
        }
        let sign = (value == (value = Math.abs(value)));
        value = Math.floor(value * 100 + 0.50000000001);
        value = Math.floor(value / 100).toString();
        for (let i = 0, length = Math.floor((value.length - (1 + i)) / 3); i < length; i++) {
            value = value.substring(0, value.length - (4 * i + 3)) + this.getConfigNumberDirective().groupSeparator + value.substring(value.length - (4 * i + 3));
        }
        value = value + decimalSeparator + decimalValue;
        return (((sign) ? '' : '-') + value) + currency_VND;
    }

    getLowcoderFormKey(): string {
        return JSON.parse(localStorage.getItem(AppStateConstant.lowcoderFormKey));
    }

    formatPhoneNumber(phone): string {
        return UtilCommon.formatPhoneNumber(phone);
    }

    getNameFromEmail(email: string): string | null {
        return UtilCommon.getNameFromEmail(email);
    }

    public addBreadcrumbMenu(menu: IBreadcumMenuItem[]): void {
        this.breadcumMenu.set(menu);
    }
}

const currency_VND = ' VNĐ';